import * as React from 'react'

import PlayIcon from '../../components/icons/play'

import * as styles from './autoplaySwitcher.module.css'

interface IProps {
  onClick: () => any
}
const AutoplaySwitcher = ({ onClick }: IProps) => (
  <div className={styles.root}>
    <span className={styles.iconContainer} onClick={onClick} role="button">
      <PlayIcon width="14" height="14" />
      <span className={styles.iconLabel}>Enable autoplay</span>
    </span>
  </div>
)

export default AutoplaySwitcher
